import React from "react";
import Logo from '../../../assets/Logo-02.png';
import FooterQR from '../../../assets/footerQR.png';
import Logo40th from '../../../assets/Logo 40th 1.png';
import Bunga from '../../../assets/Bunga.png';
import signR from '../../../assets/sign_r.png';
import signS from '../../../assets/sign_s.png';
import moment from "moment";
import Barcode from 'react-barcode';
import './css/rekapitulasi.css';
import ReactHtmlParser from 'react-html-parser';
import 'moment/locale/id';
moment.locale('id');

const numberFormat = (value) =>
  new Intl.NumberFormat("id-ID", {
    // style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);

export class ComponentToPrint extends React.PureComponent {
  render() {

    var datas = [];
    var objnew = [];
    var fd = "";
    var ld = "";


    console.log("ini printan resep", this.props.item.data)

    const datasort = this.props.item.data.sort(function (a, b) {
      return a.ID_REGISTRASI - b.ID_REGISTRASI;
    });

    const summedJson = datasort.reduce((a, { ID_REGISTRASI, TGL_LAYANAN, branch_id, branch_name, TGL_LAYANAN_FORMATTED, HARGA_KONSULTASI, METODE_PEMBAYARAN, TOTAL_HARGA }) => {
      const key = TGL_LAYANAN_FORMATTED + "_" + METODE_PEMBAYARAN;
      a[key] = a[key] || { TGL_LAYANAN_FORMATTED, TOTAL_HARGA: 0 };
      a[key].TOTAL_HARGA += TOTAL_HARGA;
      a[key].ID_REGISTRASI = ID_REGISTRASI;
      a[key].TGL_LAYANAN = TGL_LAYANAN;
      a[key].branch_id = branch_id;
      a[key].branch_name = branch_name;
      a[key].HARGA_KONSULTASI = HARGA_KONSULTASI;
      a[key].METODE_PEMBAYARAN = METODE_PEMBAYARAN;
      return a;
    }, {})


    console.log("summedJson", Object.values(summedJson));


    const _datas = Object.values(summedJson).sort(function (a, b) {
      return a.branch_id - b.branch_id;
    });

    let len = _datas.length;
    let first_value = _datas[0];
    
    let last_value = 0;
    if (_datas.length > 1) {
        last_value = _datas[len - 2];
    }else{
         last_value = _datas[len - 1];
    }
    

    fd = (moment(moment.utc(first_value.TGL_LAYANAN)).local().format("DD/MM/YYYY"));
    ld = (moment(moment.utc(last_value.TGL_LAYANAN)).local().format("DD/MM/YYYY"));
    
    
    let stringHTML = "";
    let allTotal = 0;
    
    stringHTML += "<tr><th colSpan='6' style='background-color: khaki, text-align: center'><p style='font-size: 32px'>REKAPITULASI PENERIMAAN KLINIK</p></th></tr>";
    
    if (_datas.length > 1) {
        // alert(_datas[1].branch_id)
        if (_datas[1].branch_id){
                stringHTML += "<tr><th colSpan='6' style='background-color: khaki, text-align: center'><p style='font-size: 28px'>Tanggal Penerimaan : " + fd + "-" + ld + "</p></th></tr>"
        }else{
                stringHTML += "<tr><th colSpan='6' style='background-color: khaki, text-align: center'><p style='font-size: 28px'>Tanggal Penerimaan : " + fd + "</p></th></tr>"
        }

    }else{
    stringHTML += "<tr><th colSpan='6' style='background-color: khaki, text-align: center'><p style='font-size: 28px'>Tanggal Penerimaan : " + fd + "</p></th></tr>"
    }
    

    const unique = [
      ...new Set(_datas.map((item) => item.branch_id)),
    ];

    const rowLen = unique.length;
    let obj = "";
    unique.map(function (key, i) {
      if (rowLen === i + 1) {
        obj = obj + (key + ":[]");
      } else {
        obj = obj + (key + ":[],");
      }
    });

    let obj_ = "{" + obj + "}";
    let jsonStr = obj_.replace(/(\w+:)|(\w+ :)/g, function (matchedStr) {
      return '"' + matchedStr.substring(0, matchedStr.length - 1) + '":';
    });


    console.log("jsonStr", _datas);

    // BUAT PERHITUNGAN HARI DISINI


    let obj_new = JSON.parse(jsonStr);
    unique.map(function (key, i) {
      let obj_array = [];
      let obj_key = '';
      _datas.map(function (i) {
        if (i["branch_id"] == key) {

          let z = {
            "ID_REGISTRASI": i["ID_REGISTRASI"],
            // "NOMR": i["NOMR"],
            // "NOREG": i["NOREG"],
            // "DATE_REGISTRASI": i["DATE_REGISTRASI"],
            // "NAMA_PASIEN": i["NAMA_PASIEN"],
            "TGL_LAYANAN": i["TGL_LAYANAN"],
            // "STATUS": i["STATUS"],
            // "PEMBAYARAN_KONSULTASI": i["PEMBAYARAN_KONSULTASI"],
            // "PEMBAYARAN_DISKON": i["PEMBAYARAN_DISKON"],
            // "name": i["name"],
            "branch_id": i["branch_id"],
            "branch_name": i["branch_name"],
            // "KODE_KONSULTASI": i["KODE_KONSULTASI"],
            // "NAMA_KONSULTASI": i["NAMA_KONSULTASI"],
            // "KATEGORI_KONSULTASI": i["KATEGORI_KONSULTASI"],
            "HARGA_KONSULTASI": i["HARGA_KONSULTASI"],
            // "DATE_PEMBAYARAN": i["DATE_PEMBAYARAN"],
            "METODE_PEMBAYARAN": i["METODE_PEMBAYARAN"],
            "TOTAL_HARGA": i["TOTAL_HARGA"],
            // "STATUS_PEMBAYARAN": i["STATUS_PEMBAYARAN"]
          }

          obj_array.push(z);
          console.log("sama", z);
          obj_key = key;

        }
      });

      const _datas2 = obj_array.sort(function (a, b) {
        return a.order - b.order;
      });

      _datas2.map(function (item) {
        obj_new[obj_key].push(item);
      });

      console.log("obj_new", obj_new);

    });

    datas = _datas;
    objnew = obj_new;

    console.log("INI PROPS DOWNLOAD EXCEL", obj_new)

    // const tableRef = useRef(null);

    // const returnHTML = () => {




    Object.keys(objnew).map(function (key) {
      let x = objnew[key];
      let z = datas.find(el => el.branch_id == key);

      if (z) {

        // if (z.branch_name) {
        //   stringHTML += '<tr>';
        //   stringHTML += "<td colSpan='6' style='text-align:center;background-color: #00674F; color : white; font-weight:bold'>" + z.branch_name + "</td>";
        //   stringHTML += '</tr>';
        // }
        if (z.branch_name) {
          stringHTML += '<tr>';
          stringHTML += "<td colSpan='6' style='color:black;'><p style='font-weight:bold'>" + z.branch_name + "</p></td>";
          stringHTML += '</tr>';
        }

        // stringHTML += "<tr style='background-color: khaki; text-align: center; font-weight: bold'>" +
        //   "<td>TGL REG.</td>" +
        //   "<td>BCA</td>" +
        //   "<td>CIMB</td>" +
        //   "<td>KAS</td>" +
        //   "<td>DANA</td>" +
        //   "<td>OVO</td>" +
        //   "</tr>";

        stringHTML += "<tr style='text-align: center; font-weight: bold'>" +
          "<td>TGL REG.</td>" +
          "<td>BCA</td>" +
          "<td>CIMB</td>" +
          "<td>KAS</td>" +
          "<td>DANA</td>" +
          "<td>OVO</td>" +
          "</tr>";



        // let totalKonsultasi = 0;
        // let totalDokter = 0;
        let totalHarga = 0;


        let totalBCA = 0;
        let totalCIMB = 0;
        let totalKAS = 0;
        let totalDANA = 0;
        let totalOVO = 0;

        x.map((item, i) => {

          // let col6 = "";
          // if (item.PEMBAYARAN_KONSULTASI == 0) {
          //   col6 = "-";
          // } else if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          //   col6 = "FREE";
          // } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          //   col6 = item.PEMBAYARAN_DISKON + "%";
          // } else {
          //   col6 = "";
          // }

          // let col7 = "";
          // if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          //   col7 = "0";
          // } else if (item.PEMBAYARAN_KONSULTASI == 0) {
          //   col7 = item.HARGA_KONSULTASI - ((25 / 100) * item.HARGA_KONSULTASI);
          // } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          //   col7 = (item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI)) - ((25 / 100) * (item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI)));
          // } else {
          //   col7 = "";
          // }

          // let col8 = "";
          // if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          //   col8 = "0";
          // } else if (item.PEMBAYARAN_KONSULTASI == 0) {
          //   col8 = (25 / 100) * item.TOTAL_HARGA;
          // } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          //   col8 = ((25 / 100) * (item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI)));
          // } else {
          //   col8 = "";
          // }

          // let num = 0;
          // let num2 = 0;
          // let num3 = 0;

          // if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
          //   num = 0;
          //   num2 = 0;
          //   num3 = 0;
          // } else if (item.PEMBAYARAN_KONSULTASI == 0) {
          //   num = Number(item.HARGA_KONSULTASI - ((25 / 100) * item.HARGA_KONSULTASI));
          //   num2 = Number((25 / 100) * item.TOTAL_HARGA);
          //   num3 = Number(item.TOTAL_HARGA);

          // } else if (item.PEMBAYARAN_KONSULTASI == 2) {
          //   let _step1 = item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI);
          //   num = Number(_step1 - ((25 / 100) * _step1));

          //   let _step2 = item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI);
          //   num2 = Number((25 / 100) * _step2);
          //   num3 = Number(item.TOTAL_HARGA);

          // } else {
          //   num = 0;
          //   num2 = 0;
          //   num3 = 0;
          // }

          // totalKonsultasi = totalKonsultasi + num;
          // totalDokter = totalDokter + num2;
          // totalHarga = totalHarga + num3

          if (z) {
            if (item.METODE_PEMBAYARAN == "EDC BCA") {
              totalHarga = totalHarga + Number(item.TOTAL_HARGA);
              totalBCA = totalBCA + Number(item.TOTAL_HARGA);
              stringHTML += '<tr style="text-align:center">' +
                '<td>' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
                '<td>' + numberFormat(item.TOTAL_HARGA) + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '</tr >'
            } else if (item.METODE_PEMBAYARAN == "EDC CIMB NIAGA") {
              totalHarga = totalHarga + Number(item.TOTAL_HARGA);
              totalCIMB = totalCIMB + Number(item.TOTAL_HARGA);
              stringHTML += '<tr style="text-align:center">' +
                '<td>' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
                '<td>0</td>' +
                '<td>' + numberFormat(item.TOTAL_HARGA) + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '</tr >'
            } else if (item.METODE_PEMBAYARAN == "Cash") {
              totalHarga = totalHarga + Number(item.TOTAL_HARGA);
              totalKAS = totalKAS + Number(item.TOTAL_HARGA);
              stringHTML += '<tr style="text-align:center">' +
                '<td>' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>' + numberFormat(item.TOTAL_HARGA) + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '</tr >'
            } else if (item.METODE_PEMBAYARAN == "DANA") {
              totalHarga = totalHarga + Number(item.TOTAL_HARGA);
              totalDANA = totalDANA + Number(item.TOTAL_HARGA);
              stringHTML += '<tr style="text-align:center">' +
                '<td>' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>' + numberFormat(item.TOTAL_HARGA) + '</td>' +
                '<td>0</td>' +
                '</tr >'
            } else if (item.METODE_PEMBAYARAN == "OVO") {
              totalHarga = totalHarga + Number(item.TOTAL_HARGA);
              totalOVO = totalOVO + Number(item.TOTAL_HARGA);
              stringHTML += '<tr style="text-align:center">' +
                '<td>' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>' + numberFormat(item.TOTAL_HARGA) + '</td>' +
                '</tr >'
            } else {
              totalHarga = totalHarga + Number(item.TOTAL_HARGA);
              stringHTML += '<tr style="text-align:center">' +
                '<td>' + moment(moment.utc(item.TGL_LAYANAN)).local().format("DD/MM/YYYY") + '</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '<td>0</td>' +
                '</tr >'
            }

          } else {
            stringHTML += '<tr>' +
              '<td style="text-align:center"></td>' +
              '<td></td>' +
              '<td></td>' +
              '<td></td>' +
              '<td></td>' +
              '<td></td>' +
              '</tr >'
          }


        });




        if (z) {

          // stringHTML += "<tr style='background-color:#90EE90;text-align:center' >" +
          //   "<td><b>Rp.</b></td>" +
          //   "<td><b>" + numberFormat(totalBCA) + "</b></td>" +
          //   "<td><b>" + numberFormat(totalCIMB) + "</b></td>" +
          //   "<td><b>" + numberFormat(totalKAS) + "</b></td>" +
          //   "<td><b>" + numberFormat(totalDANA) + "</b></td>" +
          //   "<td><b>" + numberFormat(totalOVO) + "</b></td>" +
          //   '</tr >'

          stringHTML += "<tr style='text-align:center' >" +
            "<td><b>Rp.</b></td>" +
            "<td><b>" + numberFormat(totalBCA) + "</b></td>" +
            "<td><b>" + numberFormat(totalCIMB) + "</b></td>" +
            "<td><b>" + numberFormat(totalKAS) + "</b></td>" +
            "<td><b>" + numberFormat(totalDANA) + "</b></td>" +
            "<td><b>" + numberFormat(totalOVO) + "</b></td>" +
            '</tr >'

          stringHTML += '<tr>' +
            "<td style='color:white'>line</td>" +
            "<td style='color:white'></td>" +
            "<td style='color:white'></td>" +
            "<td style='color:white'></td>" +
            "<td style='color:white'></td>" +
            "<td style='color:white'></td>" +
            '</tr >'
        }



        allTotal = allTotal + totalHarga;

      }
    })



    // stringHTML += '<tr>' +
    //   "<td style='background-color:#339966;color:white'></b></td>" +
    //   "<td style='background-color:#339966;color:white'></b></td>" +
    //   "<td style='background-color:#339966;color:white'></b></td>" +
    //   "<td style='background-color:#339966;color:white'></b></td>" +
    //   "<td style='background-color:#339966;color:white'></b></td>" +
    //   "<td style='background-color:#339966;color:white'></b></td>" +
    //   '</tr >'

    stringHTML += '<tr>' +
      "<td style='background-color:#339966;color:white;text-align:right' colSpan='5'><b>TOTAL KESELURUHAN:</b></td>" +
      "<td style='background-color:#339966;color:white;text-align:center'><b> " + numberFormat(allTotal) + "</b></td>" +
      '</tr >'

    // return stringHTML
    // };

    return (
      <div
        // className="container-fluid"
        style={{
          // maxWidth: "1240px",
          // maxHeight: "874px",
          // backgroundImage: 'url(' + { Bunga } + ')',
          // backgroundPosition: 'center',
          // backgroundRepeat: 'no-repeat',
          // backgroundSize: 'cover',+++++++

        }}
      >
        <div id="ui-view" data-select2-id="ui-view">
          <div>
            <table style={{
              tableLayout: "fixed",
              width: "100%",
              // border: '1px solid'
            }}
              // className="table"
              // ref={tableRef}
              className='hide-print table-rekap'
            >
              <tbody>

                {datas.length > 0 ? ReactHtmlParser(stringHTML)
                  : null}


              </tbody>
            </table>
          </div>
        </div>
      </div>
    );

  }
}